// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_user_container__tSZYF {
  flex: 1 1;
  cursor: pointer;
}

.Profile_user_name__j1TBk {
  padding-right: 25px;
  font-size: 11px;
  font-weight: 500;
  text-align: right;
  letter-spacing: 0.6px;
}

.Profile_user_icon__oFq0- {
  margin-right: 25px;
  transform: scale(1.41);
  color: var(--color-theme-blue);
}

.Profile_right_container__n-XSh {
  flex: 1 1;
  text-align: right;
  min-width: 400px;
  display: flex;
  overflow-y: scroll;
}

.Profile_MuiButtonBaseRoot__XoEIk {
  text-transform: "none";
  border-radius: 0 !important;
  height: 89px;
  width: 340px;
  color: var(--color-theme-10) !important;
}

.Profile_MuiButtonBaseRoot__XoEIk:hover {
  background-color: var(--color-theme-lightblue) !important;
}

.Profile_menu__QJQ\\+H {
  overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/Profile/Profile.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".user_container {\n  flex: 1 1;\n  cursor: pointer;\n}\n\n.user_name {\n  padding-right: 25px;\n  font-size: 11px;\n  font-weight: 500;\n  text-align: right;\n  letter-spacing: 0.6px;\n}\n\n.user_icon {\n  margin-right: 25px;\n  transform: scale(1.41);\n  color: var(--color-theme-blue);\n}\n\n.right_container {\n  flex: 1;\n  text-align: right;\n  min-width: 400px;\n  display: flex;\n  overflow-y: scroll;\n}\n\n.MuiButtonBaseRoot {\n  text-transform: \"none\";\n  border-radius: 0 !important;\n  height: 89px;\n  width: 340px;\n  color: var(--color-theme-10) !important;\n}\n\n.MuiButtonBaseRoot:hover {\n  background-color: var(--color-theme-lightblue) !important;\n}\n\n.menu {\n  overflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"user_container": `Profile_user_container__tSZYF`,
	"user_name": `Profile_user_name__j1TBk`,
	"user_icon": `Profile_user_icon__oFq0-`,
	"right_container": `Profile_right_container__n-XSh`,
	"MuiButtonBaseRoot": `Profile_MuiButtonBaseRoot__XoEIk`,
	"menu": `Profile_menu__QJQ+H`
};
export default ___CSS_LOADER_EXPORT___;
